/**
 * Segmented-bar CSS mechanics shared by ButtonGroup, PillGroup and PillTabs.
 * Only the byte-identical mechanics live here — geometry and skin (radius,
 * colours, offsets, durations, extra hide triggers) stay with each consumer.
 */

/**
 * Rounded keyline container: inner padding plus the inset keyline + bottom-edge
 * shadow. Shared by ButtonGroup and PillTabs; PillGroup's bar keeps its own
 * chip-shadow container.
 */
export const segmentedPillContainerClasses = "p-1 shadow-keyline-inset";

/** Hover pill painted by ::before behind the item content, revealed by opacity. */
export const segmentedPillHoverPillClasses =
  "before:pointer-events-none before:absolute before:inset-y-0 before:opacity-0 before:transition-opacity";

/**
 * 1px inter-item divider painted by ::after, vertically centred at the item's
 * trailing edge; the last item paints none. Consumers set the exact right
 * offset, height and colour.
 */
export const segmentedPillDividerClasses =
  "after:pointer-events-none after:absolute after:top-1/2 after:w-px after:-translate-y-1/2 after:transition-opacity last:after:hidden";

/** Divider hides while its own item — or the item after it — is hovered. */
export const segmentedPillDividerHideOnHoverClasses = "hover:after:opacity-0 has-[+[data-hovered]]:after:opacity-0";
